import { render, staticRenderFns } from "./StatPctWhycare.vue?vue&type=template&id=1e7869c2&scoped=true&lang=html"
import script from "./StatPctWhycare.vue?vue&type=script&lang=js"
export * from "./StatPctWhycare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7869c2",
  null
  
)

export default component.exports